import React from 'react';

import './styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { IconButton } from '@mui/material';

interface WidgetButtonProps {
  icon: IconProp;
  onClick: () => void;
}

const WidgetButton: React.FC<WidgetButtonProps> = ({ icon, onClick }) => {
  return (
    <IconButton className="widget-button" onClick={onClick}>
      <FontAwesomeIcon icon={icon} className="icon" />
    </IconButton>
  );
};

export default WidgetButton;
